import {
  Container,
  Stack,
  Button,
  ThemeProvider,
  useTheme,
} from "@mui/material";
import React from "react";
import { authTheme } from "./theme";
import { CoiledLogo } from "../icons/CoiledLogoWithSlogan";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { Urls } from "../domain/urls";
import { REDIRECT_URI_PARAM } from "./constants";

type Props = {
  children: React.ReactNode;
};

export const AuthTheme = (props: Props): React.ReactElement => {
  return <ThemeProvider theme={authTheme}>{props.children}</ThemeProvider>;
};

export const AuthLayout = (props: Props): React.ReactElement => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  // Preserve redirect_uri parameter when navigating between login and signup
  const redirectUri = searchParams.get(REDIRECT_URI_PARAM);
  const signUpUrl = redirectUri
    ? {
        pathname: `/${Urls.SignUp}`,
        search: `?${REDIRECT_URI_PARAM}=${encodeURIComponent(redirectUri)}`,
      }
    : { pathname: `/${Urls.SignUp}` };
  const loginUrl = redirectUri
    ? {
        pathname: `/${Urls.Login}`,
        search: `?${REDIRECT_URI_PARAM}=${encodeURIComponent(redirectUri)}`,
      }
    : { pathname: `/${Urls.Login}` };

  return (
    <Container maxWidth="xl">
      <Stack direction="row" justifyContent="space-between">
        <Link to={Urls.Root} style={{ color: theme.palette.primary.dark }}>
          <CoiledLogo sx={{ width: "180px", height: "180px" }} />
        </Link>
        <Stack direction="row" alignItems="center" spacing={2}>
          {pathname !== "/signup" && (
            <Button component={Link} to={signUpUrl}>
              Sign Up
            </Button>
          )}
          {pathname !== "/login" && (
            <Button component={Link} to={loginUrl}>
              Login
            </Button>
          )}
        </Stack>
      </Stack>
      {props.children}
    </Container>
  );
};
